import { render, staticRenderFns } from "./MoneyAmountField.vue?vue&type=template&id=24f4228a&"
import script from "./MoneyAmountField.vue?vue&type=script&lang=ts&"
export * from "./MoneyAmountField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports